import { useState } from '@hookstate/core';
import GlobalState from '../GlobalState';
import GlobalStateTransform from '../GlobalStateTransform';

export default function useGlobalState() {
  const state = useState(GlobalState);
  return GlobalStateTransform(state);
}
